// src/api/doctorApi.ts

import { createAsyncThunk } from "@reduxjs/toolkit"
import { queApi, handleApiResponse } from "@core/api/core"
import { DoctorSerializer, DoctorListResponse } from "@/types/doctor"

export const getMemberPublicDoctors = async (): Promise<DoctorSerializer[]> => {
  const requestUrl = `/member/public/doctor/`
  const response = await queApi.get<DoctorListResponse>(requestUrl)
  return handleApiResponse<DoctorSerializer[]>(response)
}

export const fetchMemberPublicDoctors = createAsyncThunk<
  DoctorSerializer[], // 성공 시 반환 타입
  void, // ThunkArg: 인자 없이 호출하려면 void
  { rejectValue: string } // ThunkAPIConfig: rejectWithValue 의 리턴 타입
>("doctor/fetchMemberPublicDoctors", async (_: void, { rejectWithValue }) => {
  try {
    return await getMemberPublicDoctors()
  } catch (err: any) {
    return rejectWithValue(err.message || "목록을 불러오는 중 오류가 발생했습니다.")
  }
})
